import { render } from "./investigator-main.html?vue&type=template&id=4d5d02c2&scoped=true&ts=true&external"
import script from "./investigator-main.ts?vue&type=script&lang=ts&external"
export * from "./investigator-main.ts?vue&type=script&lang=ts&external"

import "./investigator-main.scss?vue&type=style&index=0&id=4d5d02c2&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5d02c2"]])

export default __exports__